import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useContent() {
  return useQuery({
    queryKey: ["content"],
    queryFn: async () => (await api.get("/api/content")).data,
    staleTime: Infinity,
  });
}

export function useProgress() {
  return useQuery({
    queryKey: ["progress"],
    queryFn: async () => (await api.get("/api/progress")).data,
  });
}

export function useEntry(monthId) {
  return useQuery({
    queryKey: ["entry", monthId],
    queryFn: async () => (await api.get(`/api/entries/${monthId}`)).data,
    enabled: monthId !== undefined && monthId !== null,
  });
}

export function useEntries() {
  return useQuery({
    queryKey: ["entries"],
    queryFn: async () => (await api.get("/api/entries")).data,
  });
}

export function useSaveEntry(monthId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => (await api.put(`/api/entries/${monthId}`, payload)).data,
    onSuccess: (data) => {
      qc.setQueryData(["entry", monthId], data);
      qc.invalidateQueries({ queryKey: ["progress"] });
      qc.invalidateQueries({ queryKey: ["entries"] });
    },
  });
}
